<template>
  <ComplianceDataFieldRow
    :label="data.label"
    :value="data.date ? formatReviewDate(data.date) : null"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { formatReviewDate } from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const ComplianceDataDateFragment = graphql(`
  fragment ComplianceDataDate on ComplianceDataDate {
    label
    date
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataDateFragment> }>()
const data = computed(() => useFragment(ComplianceDataDateFragment, props.entry))
</script>
